/* eslint-disable */
const currentUserTest = {
    id    : 'current-user',
    name  : 'Quest 4 Fuel',
    email : 'game@company.com',
    avatar: 'assets/images/games/quest4fuel.png',
    status: 'online',
    position  : 1,
    info: 'Evil Zeppelin'
}

export const leaders = [
    {
        id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
        name  : 'Oh My Cat!',
        email : 'game@company.com',
        avatar: 'assets/images/games/ohmycat.png',
        status: 'online',
        position  : 1,
        info: 'Multiplayer'
    },
    {
        id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
        name  : 'Block Wars',
        email : 'game@company.com',
        avatar: 'assets/images/games/block-wars.png',
        status: 'online',
        position  : 2,
        info: 'Aeria Canada Studio'
    },
    {
        id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
        name  : 'Rock Crawling',
        email : 'game@company.com',
        avatar: 'assets/images/games/rock-crawling.png',
        status: 'online',
        position  : 3,
        info: 'TapNation'
    },
    {
        id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
        name  : 'Rescue Robots',
        email : 'game@company.com',
        avatar: 'assets/images/games/rescue-robots.png',
        status: 'online',
        position  : 4,
        info: 'Aeria Games Canada'
    },
    {
        id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
        name  : 'Runestone Keeper',
        email : 'game@company.com',
        avatar: 'assets/images/games/runestone-keeper.png',
        status: 'online',
        position  : 5,
        info: 'CIMU Games'
    }
];

export const leaderboard = [
    {
        category: 'Retention',
        title: 'Top Retention',
        users: leaders,
        info: 'A game leaderboard position is calculated using the sum of its Day 1, 7 and 30 retentions. The highest sum would be the top position on the leaderboard.',
    },
    {
        category: 'DAU',
        title: 'Top DAU',
        users: [currentUserTest, ...leaders],
        info: 'Info that goes into DAU tooltip',
    },
    {
        category: 'ARPDAU',
        title: 'Top ARPDAU',
        users: leaders,
        info: 'Info that goes into ARPDAU tooltip',
    }
];

export const currentUser = {
    id    : 'current-user',
    name  : 'Astral Raiders',
    email : 'game@company.com',
    avatar: 'assets/images/games/astral-raiders.png',
    status: 'online',
    position  : 11,
    info: 'Evil Zeppelin'
}
